import type { WalkInSlotAvailabilityProperties } from "./getWalkInAvailabilitySlotStatus";
import isWalkInSlotAvailable from "./isWalkInSlotAvailable";

type WalkInDayAvailabilityStatus = "loading" | "available" | "unavailable";

/**
 * Walk-in counterpart of `getDayAvailabilityStatus`.
 * A day is available when at least one slot is bookable for `people` via
 * {@link isWalkInSlotAvailable}. Removable with `model/walkIn`.
 */
export default function getWalkInDayAvailabilityStatus(
  dayAvailability:
    Array<WalkInSlotAvailabilityProperties | null> | undefined | null,
  people?: number,
): WalkInDayAvailabilityStatus {
  if (dayAvailability === undefined) {
    return "loading";
  }

  if (dayAvailability === null) {
    return "unavailable";
  }

  const hasSomeAvailability = dayAvailability.some((slot) => {
    if (slot === null) {
      return false;
    }

    return isWalkInSlotAvailable(slot, people);
  });

  if (hasSomeAvailability) {
    return "available";
  }

  return "unavailable";
}
